import { Tab } from '@mui/material';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { QueryTabPanel, QueryTabs } from 'components';
import { AppConfigArea } from 'enums';
import { useQueryTab } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { AppearanceCommonTab } from './AppearanceCommonTab';
import { ConfigsPage } from './ConfigsPage';
import { P2PProvidersCommonTab } from './P2PProvidersCommonTab';
import { PlatformCommonTab } from './PlatformCommonTab';
import { TronTab } from './TronTab';

enum Tabs {
  Platform = 'platform',
  Appearance = 'appearance',
  Tron = 'tron',
  P2PProviders = 'p2p_providers',
}

const TAB_AREAS: Record<Tabs, AppConfigArea> = {
  [Tabs.Platform]: AppConfigArea.Platform,
  [Tabs.Appearance]: AppConfigArea.Appearance,
  [Tabs.Tron]: AppConfigArea.Tron,
  [Tabs.P2PProviders]: AppConfigArea.P2PProvidersCommon,
};

export const CommonConfigsPage: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const { tab } = useQueryTab();
  const area = useMemo(() => TAB_AREAS[tab as Tabs], [tab]);

  return (
    <ConfigsPage area={area}>
      <Fragment>
        <QueryTabs tabsEnum={Tabs}>
          <Tab value={Tabs.Platform} label={t('tabs.platform')} />
          <Tab value={Tabs.Appearance} label={t('tabs.appearance')} />
          <Tab value={Tabs.Tron} label={t('tabs.tron')} />
          <Tab value={Tabs.P2PProviders} label={t('tabs.p2p_providers')} />
        </QueryTabs>
        <QueryTabPanel value={Tabs.Platform}>
          <PlatformCommonTab />
        </QueryTabPanel>
        <QueryTabPanel value={Tabs.Appearance}>
          <AppearanceCommonTab />
        </QueryTabPanel>
        <QueryTabPanel value={Tabs.Tron}>
          <TronTab />
        </QueryTabPanel>
        <QueryTabPanel value={Tabs.P2PProviders}>
          <P2PProvidersCommonTab />
        </QueryTabPanel>
      </Fragment>
    </ConfigsPage>
  );
};
